// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"GalleryPhotoSocial-styles__wrapper__1351dfe3","icon":"GalleryPhotoSocial-styles__icon__1351dfe3"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/gallery/components/GalleryPhotoSocial-styles.scss
// module id = 1026
// module chunks = 7 23 26 27